import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { BarriosHero } from '../../components/barrios-landing/BarriosHero';
import { BarrioSearch } from '../../components/barrios-landing/BarrioSearch';
import { SocialProof } from '../../components/barrios-landing/SocialProof';
import { WhyFresh } from '../../components/barrios-landing/WhyFresh';
import { ProblemSection } from '../../components/barrios-landing/ProblemSection';
import { TrustedDelivery } from '../../components/barrios-landing/TrustedDelivery';
import { CountriesSlider } from '../../components/barrios-landing/CountriesSlider';
import { BarriosStandard } from '../../components/barrios-landing/BarriosStandard';
import { Professionalize } from '../../components/barrios-landing/Professionalize';
import { TargetAudience } from '../../components/barrios-landing/TargetAudience';
import { BarriosProducts } from '../../components/barrios-landing/BarriosProducts';
import { FinalCTA } from '../../components/barrios-landing/FinalCTA';
import { SEOBlock } from '../../components/barrios-landing/SEOBlock';
import type { BarriosLandingProps } from '../../types/barrios-landing';

export default function BarriosLanding({ stats, countries, allBarrios, featuredProducts, appUrl, loginUrl, whatsappUrl }: BarriosLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>Frutas y Verduras Frescas en Barrios Privados | Abasto Virtual</title>
        <meta
          name="description"
          content="Delivery de frutas y verduras frescas a barrios privados y countries de Córdoba. Selección diaria del Mercado de Abasto, entrega programada."
        />
        <link rel="canonical" href={`${appUrl}/barrios-privados`} />
      </Head>

      <BarriosHero loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <BarrioSearch barrios={allBarrios} />
      <SocialProof stats={stats} />
      <WhyFresh />
      <ProblemSection />
      <TrustedDelivery />
      <CountriesSlider countries={countries} />
      <BarriosStandard />
      <Professionalize />
      <TargetAudience />
      <BarriosProducts products={featuredProducts} />
      <FinalCTA loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <SEOBlock appUrl={appUrl} />
    </MainLayout>
  );
}
